import React from 'react';
import { Grape, Baby } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const T = {
  official: { es: 'Guachinche oficial', en: 'Official guachinche', de: 'Offizieller Guachinche' },
  kids: { es: 'Niños', en: 'Kids', de: 'Kinder' },
  explain: {
    es: 'Inscrito en el registro de guachinches del Cabildo de Tenerife (Decreto 83/2013).',
    en: 'Listed in the official guachinche register of the Cabildo de Tenerife (Decree 83/2013).',
    de: 'Eingetragen im offiziellen Guachinche-Register des Cabildo de Tenerife (Dekret 83/2013).',
  },
  checked: { es: 'Comprobado el', en: 'Checked on', de: 'Geprüft am' },
};
const LOCALE = { es: 'es-ES', en: 'en-GB', de: 'de-DE' };

export const OfficialGuachincheBadge = ({ size = 'sm', testId = 'official-guachinche-badge' }) => {
  const { language } = useLanguage();
  const cls = size === 'lg' ? 'text-sm px-3 py-1.5 gap-1.5' : 'text-[11px] px-2 py-1 gap-1';
  return (
    <span className={`inline-flex items-center font-semibold text-white bg-[#7B2D3A] whitespace-nowrap ${cls}`} data-testid={testId}>
      <Grape size={size === 'lg' ? 15 : 12} /> {T.official[language] || T.official.es}
    </span>
  );
};

export const KidsBadge = ({ size = 'sm', testId = 'kids-badge' }) => {
  const { language } = useLanguage();
  const cls = size === 'lg' ? 'text-sm px-3 py-1.5 gap-1.5' : 'text-[11px] px-2 py-1 gap-1';
  return (
    <span className={`inline-flex items-center font-semibold text-white bg-[#38B2AC] whitespace-nowrap ${cls}`} data-testid={testId}>
      <Baby size={size === 'lg' ? 15 : 12} /> {T.kids[language] || T.kids.es}
    </span>
  );
};

/** Sello + explicación para la ficha */
export const OfficialGuachincheNote = ({ checkedAt }) => {
  const { language } = useLanguage();
  const date = checkedAt ? new Date(`${checkedAt}T12:00`).toLocaleDateString(LOCALE[language] || LOCALE.es, { day: 'numeric', month: 'long', year: 'numeric' }) : null;
  return (
    <div className="border-l-4 border-[#7B2D3A] bg-[#7B2D3A]/5 px-4 py-3" data-testid="official-guachinche-note">
      <OfficialGuachincheBadge size="lg" testId="official-guachinche-badge-detail" />
      <p className="text-sm text-gray-700 mt-2">{T.explain[language] || T.explain.es}</p>
      {date && <p className="text-xs text-gray-500 mt-1" data-testid="official-guachinche-checked">{T.checked[language] || T.checked.es} {date}</p>}
    </div>
  );
};
